import { render, staticRenderFns } from "./bindMec.vue?vue&type=template&id=38ba7af9&scoped=true&"
import script from "./bindMec.vue?vue&type=script&lang=js&"
export * from "./bindMec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ba7af9",
  null
  
)

export default component.exports